import apiRequest from './apiRequest';

export default async function deleteOrganizationInvite(
  organizationID: string,
  inviteID: string,
) {
  return apiRequest<{ ok: boolean }>(
    'user',
    `/organizations/${encodeURIComponent(organizationID)}/invites/${encodeURIComponent(inviteID)}`,
    { method: 'DELETE' },
  );
}
